<template>
  <div style="font-size: 18px; padding: 20px; word-break: break-all;">
    <h1>404</h1>

    <h3>FM page not found</h3>

    <div>{{ href }}</div>
    <br />

    <a href="/">回到主页</a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      href: ''
    }
  },

  mounted() {
    this.href = location
  }
}
</script>